import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import routes from 'router/routes';
import Routes from 'router/components/Routes/Routes';
import ErrorBoundary, { ErrorFallback } from 'components/ErrorBoundary';
import PopNotificationsProvider from 'providers/PopNotifications';
import AuthProvider from 'providers/Auth';

function App() {
  return (
    <ErrorBoundary fallback={ErrorFallback}>
      <BrowserRouter>
        <PopNotificationsProvider>
          <AuthProvider>
            <Routes routes={routes} />
          </AuthProvider>
        </PopNotificationsProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
